let request = new XMLHttpRequest()
request.open("GET", window.location.origin  + "/api/v0/api/oidc-config", false)
request.send(null)

export const oidcSettings = JSON.parse(JSON.parse(request.responseText).Body);